import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getContestActiveList } from "../../../../../redux/contest/action";
import ListLoader from "../../../../CustomComponents/AllLoader/ListLoader";
import {
  getMemberSince,
  getRemaindays,
} from "../../../../Common/AllDateTimeReleventFormate";
import LabelgetRemaindays from "../../../../Common/CustomeLabel/LabelgetRemaindays";
import CustomeDeadlineDateLabel from "../../../../Common/CustomeLabel/CustomeDeadlineDateLabel";
import { useRouteBaseStateContext } from "../../../../../Context/RouteBaseStateContext";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";
import { PAGE_SIZE } from "../../../../../redux/constants";
import { getPostPaginationList } from "../../../../../redux/project/action";
import OrderPostPagination from "../../../FindWork/SearchAll/AllPosts/CustomPagination/OrderPostPagination";

export default function ActiveContest() {
  const { setManageActivecontestroute } = useRouteBaseStateContext();
  const path = "Assets/scss/myorders.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const navigate = useNavigate();
  
  // const listdata?.response = useSelector(
  //   ({ contest: { listdata?.response } }) => listdata?.response,
  // );
  // const dispatch = useDispatch();

  // useEffect(() => {
    // dispatch(getContestActiveList(2));
  // }, []);


  const [listdata, setListdata] = useState("")
  const [pageNumber, setPageNumber] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    const data = {
      type: 2,
      index: pageNumber,
      size: PAGE_SIZE,
      status: 11
    }
    if (data) {
      dispatch(getPostPaginationList(data)).then((res) => {
        setListdata(res)
      })
    }
  }, [pageNumber]);



  return (
    <div className ="order-tabs">
      <div className ="tab-content">
        <div className ="posted-project">
          {Array.isArray(listdata?.response) && (
            <>
              <h4>Win business Opportunities (WBO)</h4>
               <OrderPostPagination
                totalitemcounts={listdata?.count}
                size={PAGE_SIZE}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
              />
              {listdata?.response?.length == 0 && <PostNotFound title={"No Post Found"} />}
              <div className ="recent-post">
                {listdata?.response.slice(0, 10).map((item, index) => (
                  <div className ="post-back">
                    <div className ="col-md-5 ">
                      <h3>{item?.title}</h3>
                      <div className ="post-img">
                        <CustomeDeadlineDateLabel
                          type={item?.type}
                          last_date={item?.last_date}
                        />
                        <LabelgetRemaindays last_date={item?.last_date} />
                      </div>
                    </div>
                    <div className ="activity col-md-4">
                      <h6>Activity</h6>
                      <div className ="post-img">
                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/project/post-proposal.svg`}
                            alt=""
                          />
                          Entries: {item?.proposal_count}
                        </p>
                      </div>
                    </div>
                    <button
                      className ="btn"
                      onClick={() => {
                        navigate(
                          `/${lan}/dashboard/managework/contests/active/${item.id}`,
                        );
                        setManageActivecontestroute("");
                      }}
                    >
                      View details
                      <img
                        src={`${CloudStorage.cloudurl}Assets/Images/homepage/right-arrow-orange.svg`}
                        alt=""
                      />
                    </button>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
